<template lang="pug">
  .navigation.sidebar
    .navigation-item(v-for="item in items" v-if="checkPerms(item) == true && item.name")
      li(:id="'mnu-' + item.name" v-bind:class="{ parent: exists(item.children), active: subNavigationActive(item.path) }" v-bind:style="iconStyle(item.meta)") 
        router-link(v-if="noLink(item.meta)" :to="item.path") {{ $t('pages.' + item.name + '.title') }}
        a(v-else href="#") {{ $t('pages.' + item.name + '.title') }}
      ul.child-container(v-if="item.children" :id="'mnu-' + item.name + '-child'" v-bind:class="{ active: subNavigationActive(item.path) }")
        li.child(v-for="child in item.children" v-if="checkPerms(child) == true" v-bind:class="{ active: childActive(child.path) }")
          router-link(v-if="noLink(child.meta)" :to="item.path + '/' + child.path") {{ $t('pages.' + child.name + '.title') }}
          a(v-else href="#") {{ $t('pages.' + child.name + '.title') }}
    li(v-if="isLoggedIn()" @click="logout") {{ $t('pages.logout.title') }}
</template>

<script>
  var currentDropdown = '';
  export default {
    name: 'Navigation',
    data() {
      return {
        items: this.loadNavigation()
      }
    },
    methods: {
      childActive(input) {
        return this.$route.path.indexOf(input) !== -1;
      },
      subNavigationActive( input ) {
        return this.$route.path.indexOf(input) === 0;
      },
      exists(input) {
        return (input !== undefined) ? true : false;
      },
      noLink(meta) {
        if(meta !== undefined)
          if(meta.nolink !== undefined)
            return false;
        return true;
      },
      iconStyle(meta) {
        if(meta !== undefined)
          if(meta.icon !== undefined) {
            return { 'backgroundImage': 'url(' + require('@/assets/images/' + meta.icon) + ")" };
          }
        return '';
      },
      loadNavigation() {
        return this.$router.options.routes;
      }
    },
    created() {
      this.$store.watch( (state) => {
        return this.$store.state.isUserLoggedIn // could also put a Getter here
      }, (newValue, oldValue)=>{
        this.items = this.loadNavigation();
      }, {
        deep:false
      })
    }
  }
</script>

<style lang="scss" scoped>
  .navigation {
    width: 100%;
    background: $sidebar-nav-bg;

    li {
      display:block;
      background:$sidebar-nav-item;
      color:#eee;
      list-style-type:none;
      line-height:55px;
      padding-left:15px;
      background-repeat: no-repeat;
      background-position: center right 17px;
      background-size:16px;
      @media all and (max-width:1180px) {
        font-size:14px;
      }
      a {
        text-decoration:none;
        color:#eee;
      }
      
      &.active {
        background-color: $sidebar-nav-item-active;
      }

      &.child {
        background-color:$gradient-8;
      }

      &.parent {
        background-color:$gradient-9;
        background-image:url('~@/assets/images/arrow-up-white.svg');
        background-repeat:no-repeat;
        background-size:9px;
        background-position: center right 20px;
        &.active {
          background-color: $sidebar-nav-item-active;
        }
      }
    }
    .parent.active,
    .child-container.active {
      li {
        background: $sidebar-nav-item-active;
        &.active {
          background-color: $sidebar-nav-item-active-child;
        }
      }
    }
  }
</style>